// Application constants
export const VALIDATION_CONSTANTS = {
  MIN_LOAN_AMOUNT: 20000000, // £200,000 in pennies
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_REGEX: /^[\+]?[\d\s\-\(\)]{10,}$/,
} as const;

export const CURRENCY_OPTIONS = [
  { value: "US$", label: "US$ (USD)" },
  { value: "€", label: "€ (EUR)" },
  { value: "Other", label: "Other Currency" },
] as const;

export const LOAN_TYPES = [
  { value: "Residential", label: "Residential" },
  { value: "Buy to Let", label: "Buy to Let" },
] as const;

export const REPAYMENT_TYPES = [
  { value: "Repayment", label: "Repayment" },
  { value: "Interest Only", label: "Interest Only" },
  { value: "Part and Part", label: "Part and Part" },
] as const;

export const HOUSEHOLD_SIZE_OPTIONS = {
  adults: [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3+', label: '3+' },
  ],
  children: [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3+', label: '3+' },
  ],
} as const;
